/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { Grid, GridColumn, GridToolbar } from '@progress/kendo-react-grid';
import { CellRender, RowRender } from './renderers';
import { myTimeCell } from '../../framework/forms/helpercomponents/inline grid cell/MyTimeCell';
import { utility } from '../../framework/utility/utilityProvider';
import { CheckboxCell } from '../../framework/forms/helpercomponents/CustomGridCells/CheckBoxCell';
import { useTranslation } from '../../locale/useTranslation';
import { ApplicationConfigurationKeys } from '../../framework/constant/constant';
import { EnumCell } from '../../framework/forms/helpercomponents/CustomGridCells/EnumCell';

const EDIT_FIELD = 'inEdit';

const SegmentTypeCollectionTab = ({ segmentDetails = [], handleActualDuration, updatedSegmentDetails, mediaDuration = null, checkOverlappingTimecodes, checkExceedingSlotDuration, checkInvalidTimecodes, showSegmentDetailsInFullScreen = false }) => {

  const isSegmentMediaIdEditable = utility.getApplicationConfigurationByKey(ApplicationConfigurationKeys.isSegmentMediaIdEditable) ?? true;

  const [data, setData] = useState([]);
  const [actualDuration, setActualDuration] = useState('00:00:00:00');
  const [changes, setChanges] = useState(false);
  const lang = useTranslation();

  useEffect(() => {

    //SORT BY SEQUENECE
    let segDetails = [...(segmentDetails || [])].sort((a, b) => a.Sequence - b.Sequence);
    setData(segDetails);

  }, [segmentDetails])

  if (actualDuration !== null) {
    handleActualDuration(actualDuration);
  }

  const enterEdit = (dataItem, field) => {
    const newData = data.map(item => ({
      ...item,
      [EDIT_FIELD]: item.Sequence === dataItem.Sequence ? field : undefined
    }));
    console.log(dataItem);
    setData(newData);
  };

  const exitEdit = () => {
    const newData = data.map(item => ({
      ...item,
      [EDIT_FIELD]: undefined
    }));
    setData(newData);
  };

  const itemChange = event => {

    let field = event.field || '';
    event.dataItem[field] = event.value;

    let newData = data.map(item => {
      if (item.Sequence === event.dataItem.Sequence) {
        item[field] = event.value;
      }

      //IF TcIn or TcOut Changes, We will update duration
      if (field === "TcOut" || field === "TcIn") {
        if (item.Sequence === event.dataItem.Sequence) {
          let duration = utility.convertStringWithFramesToMilliseconds(event.dataItem.TcOut) - utility.convertStringWithFramesToMilliseconds(event.dataItem.TcIn);
          item['Duration'] = utility.convertMilisecondsToStringWithFrames(duration);
        }
      }
      else if (field === "Duration") // IF Duration Changes, We will update TC out Only
      {
        if (item.Sequence === event.dataItem.Sequence) {
          let tcOut = utility.convertStringWithFramesToMilliseconds(event.dataItem.TcIn) + utility.convertStringWithFramesToMilliseconds(event.dataItem.Duration);
          item['TcOut'] = utility.convertMilisecondsToStringWithFrames(tcOut);
        }

      }
      return item;
    });

    setData(newData);
    updatedSegmentDetails(newData);
    setChanges(true);
  };

  //realtime changes in endtime and duration and total duration 
  const realtimeChangeInDuration = (dataItem) => {
    let durationString = utility.convertStringWithFramesToMilliseconds(dataItem.TcOut) - utility.convertStringWithFramesToMilliseconds(dataItem.TcIn);
    let duration = utility.convertMilisecondsToStringWithFrames(durationString);
    return duration;
  }

  const customCellRender = (td, props) => <CellRender originalProps={props} td={td} enterEdit={enterEdit} editField={EDIT_FIELD} />;

  const customRowRender = (tr, props) => <RowRender originalProps={props} tr={tr} exitEdit={exitEdit} editField={EDIT_FIELD} />;

  const CalculatedDurationCell = (props) => {

    const [totalDuration, setTotalDuration] = useState("");

    useEffect(() => {
      let sum = 0;

      data.forEach((item) => {
        sum += utility.convertStringWithFramesToMilliseconds(item.Duration);
      });

      const calculatedTotalDuration = utility.convertMilisecondsToStringWithFrames(sum);
      setTotalDuration(calculatedTotalDuration);
      setActualDuration(calculatedTotalDuration);
    }, [data]);

    return (
      <td colSpan={props.colSpan} style={props.style}>
        {totalDuration}
      </td>
    );
  };

  const MyCheckBoxCell = (props) => <CheckboxCell {...props} disable={false} />;

  return (
    <div>
      {/* to add data list here */}
      <Grid resizable={true} data={data} style={{ height: showSegmentDetailsInFullScreen ? "auto" : "30vh" }} dataItemKey={'Sequence'} onItemChange={itemChange} cellRender={customCellRender} rowRender={customRowRender} editField={EDIT_FIELD}>
        <GridColumn field="Sequence" title={'Seq'} editable={false} width={'50px'} />
        <GridColumn field="MediaId" title={lang.media_id_column} editable={isSegmentMediaIdEditable} />
        <GridColumn field="TcIn" title={lang.start_time_column} cell={myTimeCell} width={'120px'} />
        <GridColumn field="TcOut" title={lang.end_time_column} cell={myTimeCell} width={'120px'} />
        <GridColumn field="Duration" title={lang.duration_column} footerCell={CalculatedDurationCell} cell={myTimeCell} width={'120px'} />
        <GridColumn field="Remarks" title={lang.remark_column} editable={true} width={'120px'} />
        <GridColumn field="SegmentDetailType" title={lang.segment_detail_type_column} cell={EnumCell} width={'100px'} />
        <GridColumn field="IsPreviewed" title={lang.previewed_column} width={'80px'} editor="boolean" cell={MyCheckBoxCell} />
      </Grid>
      {/* Check and showing Case 1 - Exceeding Slot Duration Case 2 - Overlapping Timecodes */}
      <div style={showSegmentDetailsInFullScreen
        ? { marginTop: '10px', display: 'flex', backgroundColor: 'white' }
        : { position: 'absolute', bottom: 10, left: 25, display: 'flex', backgroundColor: 'white' }}>
        {checkInvalidTimecodes() &&
          <div>
            <span style={{ color: 'red' }}>1. Invalid Duration / Timecodes</span>
          </div>}
        {checkExceedingSlotDuration() &&
          <div style={{ marginLeft: '10px' }}>
            <span style={{ color: 'red' }}>2. Exceeding Slot Duration</span>
          </div>}
        {checkOverlappingTimecodes() &&
          <div style={{ marginLeft: '10px' }}>
            <span style={{ color: 'red' }}>3. Overlapping Timecodes</span>
          </div>}
      </div>
      <div style={showSegmentDetailsInFullScreen
        ? { width: '100%', textAlign: 'right', backgroundColor: 'white', fontWeight: 'bold' }
        : { position: 'absolute', bottom: 10, right: 25, display: 'flex', backgroundColor: 'white', fontWeight: 'bold' }}
      >
        {mediaDuration ? utility.convertMilisecondsToStringWithFrames(mediaDuration) : ""}
      </div>
    </div>
  )
}

export default SegmentTypeCollectionTab